import styles from './TablePreloader.module.css';
const array = new Array(6).fill('');

const TablePreloader = () => {
   return array.map((row, index) => (
      <div key={index} style={{ marginBottom: '2rem' }}>
         <div className={styles.tds}>
            <span></span>
         </div>
      </div>
   ));
};

export default TablePreloader;